const BrandSlider = ({ logoList, direction }) => {
	return (
		<div className="logo-container">
			{Array.from({ length: 4 }).map((_, idx) => (
				<div key={idx} className={`logo-slider-${direction}`}>
					{logoList.map((logo) => (
						<img src={logo.src} alt={logo.alt} className={logo.className} />
					))}
				</div>
			))}
		</div>
	);
};

export default BrandSlider;
